var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.014,
    height: 33.611,
    viewBox: "0 0 42.014 33.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.138,4.639A5.356,5.356,0,0,0,37.462.963C34.136,0,21.007,0,21.007,0S7.878,0,4.639.875A5.356,5.356,0,0,0,.963,4.551C0,7.878,0,16.805,0,16.805s0,8.928.875,12.166a5.356,5.356,0,0,0,3.676,3.676c3.326.963,16.455.963,16.455.963s13.129,0,16.368-.875a5.356,5.356,0,0,0,3.676-3.676c.963-3.326.963-12.254.963-12.254S42.014,7.878,41.138,4.639ZM16.805,24.07V9.541l12.6,7.265Z",
    fill: "#222f3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d1a985b5f200ee75e40f178d87d1de41.svg";
export { ForwardRef as ReactComponent };